import styled, {css} from "styled-components";
import {solease_lightblue, solease_yellow} from "../../constants/Colors";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  max-width: 500px;
  margin: auto;

  &:before {
    content: '';
    width: 100%;
    position: absolute;
    height: 3px;
    background-color: ${solease_lightblue};
  }
`

const Item = styled("div")<{ active?: boolean, finished?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background-color: white;
  border: 2px solid ${solease_lightblue};
  color: ${solease_lightblue};
  transition: all .5s;

  ${props => props.active && css`
    transform: scale(1.2);
    background-color: ${solease_yellow};
    border: 2px solid white;
    color: white;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  `}

  ${props => props.finished && css`
    background-color: ${solease_lightblue};
    color: white;
  `};

  @media (min-width: 900px) {
    width: 50px;
    height: 50px;
    font-size: 32px;
  }
`

const ProgressBar = ({step}: { step: number }) => {
    return <Wrapper>
        {
            [1, 2, 3].map(item =>
                <Item key={item}
                    finished={step > item}
                    active={step === item}>
                    {item}
                </Item>)
        }
    </Wrapper>
}

export default ProgressBar
